import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { ThemeProvider } from "next-themes";
import { isSupabaseConfigured } from "@/integrations/supabase/client";
import MissingSupabaseEnv from "@/components/MissingSupabaseEnv";
import Index from "./pages/Index";
import ConfirmPage from "./pages/ConfirmPage";
import AccountConfirmation from "./pages/AccountConfirmation";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import NotFound from "./pages/NotFound";
import WebViewPage from "./pages/WebViewPage";
import ThankYouPage from "./pages/ThankYouPage";
import StripeCheckoutReturnHandler from "@/components/StripeCheckoutReturnHandler";
import PasswordRecoveryReturnHandler from "@/components/PasswordRecoveryReturnHandler";

const queryClient = new QueryClient();

const App = () => {
  if (!isSupabaseConfigured) {
    return <MissingSupabaseEnv />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <AuthProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <StripeCheckoutReturnHandler />
            <PasswordRecoveryReturnHandler />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/webview" element={<WebViewPage />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
              <Route path="/confirm" element={<ConfirmPage />} />
              <Route path="/account-confirmation" element={<AccountConfirmation />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              {/* Explicit /#/404 for bookmarks, Stripe return URLs, or future server rules */}
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </TooltipProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
